import { validateTidalLicense } from "../base/index.js";
export * from "framer-motion";
validateTidalLicense();
//# sourceMappingURL=index.js.map
